export default "__VITE_PUBLIC_ASSET__24dc32d0__"